export const ATTENDANCE_CONSTANTS = {
  MARK_ATTENDANCE: "mark_attendance",
  NOT_MARKED: "NOT_MARKED",
  MARKED: "MARKED",
  SEND_REMINDER: "send_reminder",
  ASSIGN_TEACHER: "assign_teacher",
  ATTENDANCE_DASHBOARD: "ATTENDANCE_DASHBOARD",
  STUDENTS: "STUDENTS",
  CLASSES: "CLASSES",
  DAILY: "DAILY",
  STUDENTS_PERIOD_ATTENDANCE: "STUDENTS_PERIOD_ATTENDANCE",
  STUDENTS_TAB_OVERVIEW: "STUDENTS_TAB_OVERVIEW",
  STUDENT: "STUDENT",
  ASC: "ASC",
  FIRST_NAME: "FIRST_NAME",
  MIDDLE_NAME: "MIDDLE_NAME",
  LAST_NAME: "LAST_NAME",
  FULL_NAME: "FULL_NAME",
  OVERALL_PRESENCE: "OVERALL_PRESENCE",
  ANOMALY: "ANOMALY",
  YEARLY: "YEARLY",
  CUSTOM_RANGE: "CUSTOM_RANGE",
  CLASS: "CLASS",
  TITLE: "TITLE",
  DESC: "DESC",
  FIRST_NAME_AZ: "FIRST_NAME_AZ",
  FIRST_NAME_ZA: "FIRST_NAME_ZA",
  MIDDLE_NAME_AZ: "MIDDLE_NAME_AZ",
  MIDDLE_NAME_ZA: "MIDDLE_NAME_ZA",
  LAST_NAME_AZ: "LAST_NAME_AZ",
  LAST_NAME_ZA: "LAST_NAME_ZA",
  FULL_NAME_AZ: "FULL_NAME_AZ",
  FULL_NAME_ZA: "FULL_NAME_ZA",
  MARKED_FIRST: "MARKED_FIRST",
  UNMARKED_FIRST: "UNMARKED_FIRST",
  ATTENDANCE_COUNT: "ATTENDANCE_COUNT",
  LABEL_AZ: "LABEL_AZ",
  LABEL_ZA: "LABEL_ZA",
  CLASS_EACH_PERIOD: "CLASS_EACH_PERIOD",
  SORT_ENTITY: "sortEntity",
  PRESENCE: "PRESENCE",
  AVATAR_WITH_TEXT: "AvatarWithText",
  AVATAR_WITH_SUBTEXT: "AvatarWithSubText",
  MARK_STUDENT_ATTENDANCE: "MarkStudentAttendance",
  TEXT: "Text",
  BUTTON: "Button",
  ACTION_BUTTON: "ActionButton",
  CHECKBOX: "Checkbox",
  STUDENT_EDIT_OUTLINED: "StudentEditOutlined",
  SETUP_OUTLINED: "SetupOutlined",
  EXCUSAL: "EXCUSAL",
  EXCUSALS: "EXCUSALS",
  NEW_EXCUSALS: "NEW_EXCUSALS",
  MARKED_EXCUSALS: "MARKED_EXCUSALS",
  SINGLE_DAY: "SINGLE_DAY",
  PARTIAL_DAY: "PARTIAL_DAY",
  MULTIPLE_DAYS: "MULTIPLE_DAYS",
  DURATION: "DURATION",
  ATTENDANCE: "ATTENDANCE",
  ONGOING: "ONGOING",
  UPCOMING: "UPCOMING",
  EARLIER: "EARLIER",
  PENDING: "PENDING",
  EXCUSAL_START_DATE: "EXCUSAL_START_DATE",
  DD_MMM: "DD MMM",
  YYYY_MM_DD: "YYYY-MM-DD",
  START: "START",
  END: "END",
  DAY: "day",
  START_DATE: "startDate",
  END_DATE: "endDate",
  D_MMM_YYYY: "D MMM YYYY",
  D_MMM: "D MMM",
  MMMM_YYYY: "MMMM YYYY",
  DDD_MMM_D: "ddd, MMM D",
  DIVIDER: "DIVIDER",
  MONTHLY: "MONTHLY",
  WEEKLY: "WEEKLY",
  CACHE_AND_NETWORK: "cache-and-network",
  NETWORK_STATUS: "networkStatus",
  BREAK: "BREAK",
  DATE: "date",
  WEEK: "week",
  MONTH: "month",
  PERFECT_ATTENDANCE: "PERFECT_ATTENDANCE",
  MORE_THAN_90: "MORE_THAN_90",
  LESS_THAN_90: "LESS_THAN_90",
  ATTENDANCE_MARKED_STATUS: "ATTENDANCE_MARKED_STATUS",
  PRESENT_PERCENTAGE: "PRESENT_PERCENTAGE",
  TOGGLE: "toggle",
  STAFF: "staff",
  STAFF_UPPERCASE: "STAFF",
  ROW_PREFIX: "ROW_PREFIX",
  ROW_PREFIX_KEY: "row_prefix",
  EXCUSAL_DATE_FORMAT: "D MMM YY",
  ONCE_A_DAY: "ONCE_A_DAY",
  ADMIN: "admin",
  ATTENDANCE_EXCUSAL: "ATTENDANCE_EXCUSAL",
  ATTENDANCE_EXCUSAL_PARENT_ID: "ATTENDANCE_EXCUSAL_PARENT_ID",
  ALL_PRESENT: "ALL_PRESENT",
  DD_MMM_YYYY: "DD MMM YYYY",
  ATTENDANCE_DATE: "ATTENDANCE_DATE",
  GRADE: "GRADE",
  DDD: "ddd",
  PERIODS_SETUP: "PERIODS_SETUP",
  EDIT: "EDIT",
  DELETE: "DELETE",
  DUPLICATE: "DUPLICATE",
  MODIFY: "MODIFY",
  CHANGE_ORDER: "CHANGE_ORDER",
  PRESENT: "PRESENT",
  ALL: "ALL",
  VIEW: "view",
  EDIT_CONSTANT: "edit",
  PERIODS: "periods",
  HOMEROOM_UPPERCASE: "HOMEROOM",
  HOMEROOM: "homeroom",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  UPDATE_SELECTED_DATE_OBJECT: "UPDATE_SELECTED_DATE_OBJECT",
  SET_IS_CUSTOM_RANGE_MODAL_VISIBLE: "SET_IS_CUSTOM_RANGE_MODAL_VISIBLE",
  CLASS_ONCE_A_DAY: "CLASS_ONCE_A_DAY",
  PARTIALLY_MARKED: "PARTIALLY_MARKED",
  TEACHER_NAME: "teacher_name",
  STATUS: "status",
  TOTAL_STUDENTS: "total_students",
  HOLIDAYS_AND_VACATIONS: "Holidays and vacations",
  WHOLE_SCHOOL_EVENTS: "Whole school events",
  ACTIONS: "actions",
  UID: "UID",
  EMAIL: "EMAIL",
  HOMEROOM_ADVISOR: "HOMEROOM_ADVISOR",
  ALL_CURRICULUMS: "ALL_CURRICULUMS",
  NOT_CONNECTED: "NOT_CONNECTED",
  CONNECTED: "CONNECTED",
  RESET_ATTENDANCE: "RESET_ATTENDANCE",
  ACTIVE: "ACTIVE",
  EXCUSAL_ICON: "EXCUSAL_ICON",
  ARCHIVED: "ARCHIVED",
  EACH_PERIOD: "EACH_PERIOD",
  EACH_PERIOD_WITH_ONCE_A_DAY: "EACH_PERIOD_WITH_ONCE_A_DAY",
  UPCOMING_AND_ONGOING_EXCUSALS: "UPCOMING_AND_ONGOING_EXCUSALS",
  ACTIVE_EXCUSALS: "ACTIVE_EXCUSALS",
  ALL_EXCUSALS: "ALL_EXCUSALS",
  UPDATE_EXCUSALS_SELECTED_DATE_OBJECT: "UPDATE_EXCUSALS_SELECTED_DATE_OBJECT",
  COURSE_ATTENDANCE_SUMMARY_REPORT: "COURSE_ATTENDANCE_SUMMARY_REPORT",
  COURSE_ATTENDANCE_RECORDS_REPORT: "COURSE_ATTENDANCE_RECORDS_REPORT",
  STUDENT_ATTENDANCE_SUMMARY_REPORT: "STUDENT_ATTENDANCE_SUMMARY_REPORT",
  STUDENT_ATTENDANCE_RECORDS_REPORT: "STUDENT_ATTENDANCE_RECORDS_REPORT",
  STUDENT_INDIVIDUAL_ATTENDANCE_REPORT: "STUDENT_INDIVIDUAL_ATTENDANCE_REPORT",
  HOMEROOM_ATTENDANCE_SUMMARY_REPORT: "HOMEROOM_ATTENDANCE_SUMMARY_REPORT",
  HOMEROOM_ATTENDANCE_RECORDS_REPORT: "HOMEROOM_ATTENDANCE_RECORDS_REPORT",
  STUDENT_CAMPUS_PRESENCE_GRADE_SUMMARY_REPORT:
    "STUDENT_CAMPUS_PRESENCE_GRADE_SUMMARY_REPORT",
  URL: "URL",
  EACH_PERIOD_WITH_DAILY_ATTENDANCE: "EACH_PERIOD_WITH_DAILY_ATTENDANCE",
  HOMEROOM_ALERT: "HOMEROOM_ALERT",
  REGULAR: "REGULAR",
  EN: "en",
  CLASSROOM: "CLASSROOM",
  GRADES: "GRADES",
  ALL_PERIODS: "ALL_PERIODS",
  MY_PERIODS: "MY_PERIODS",
  PRESENCE_PERCENTAGE: "PRESENCE_PERCENTAGE",
  PRESENCE_NUMBER: "PRESENCE_NUMBER",
  ABSENCE_PERCENTAGE: "ABSENCE_PERCENTAGE",
  ABSENCE_NUMBER: "ABSENCE_NUMBER",
  ALL_STUDENTS: "ALL_STUDENTS",
  ACTIVE_STUDENTS: "ACTIVE_STUDENTS",
  ARCHIVED_STUDENTS: "ARCHIVED_STUDENTS",
  HEADER: "header",
  STUDENT_NAME: "student_name",
  STUDENTWISE: "STUDENTWISE",
  ROOT: "root",
  ATTENDANCE_TYPE: "attendanceType",
  STUDENT_FILTERS: "studentFilters",
  CLASS_LOWERCASE: "class",
  PERIOD: "period",
  COMMENT: "comment",
  CLASSES_CONFIGURE_COLUMN: "AttendanceClassesTableColumns",
  HOMEROOM_CONFIGURE_COLUMN: "AttendanceHomeroomTableColumns",
  ATTENDANCE_DASHBOARD_SUMMARY_VIEW: "AttendanceDashboardSummaryView",
  ATTENDANCE_REMINDER: "ATTENDANCE_REMINDER",
  TIMETABLE: "timetable",
  ATTENDANCE_OPTION: "ATTENDANCE-OPTION",
  TERM: "TERM",
  SELECT_REPORT: "SELECT_REPORT",
  SELECT_DURATION: "SELECT_DURATION",
  SELECT_ENTITY: "SELECT_ENTITY",
  SELECT_DURATION_ONLY: "SELECT_DURATION_ONLY",
  DAILY_ATTENDANCE: "DAILY_ATTENDANCE",
  DAILY_ATTENDANCE_CAMEL_CASE: "DailyAttendance",
  ROTATION_CYCLE: "ROTATION_CYCLE",
  CREATE: "CREATE",
  ATTENDANCE_CATEGORY: "ATTENDANCE-CATEGORY",
  CODES: "CODES",
  CATEGORIES: "CATEGORIES",
  CODES_AND_CATEGORIES: "CODES_AND_CATEGORIES",
  TIERS: "TIERS",
  HOMEROOM_CLASS: "HOMEROOM_CLASS",
  RAISE_EXCUSAL: "RAISE_EXCUSAL",
  SCHEDULE_PERIOD: "SCHEDULE_PERIOD",
  ALL_CLASS: "ALL_CLASS",
};
